import popoutMenu from './features/popout-menu';
import { EVENT, IS_VISIBLE } from './constants';

export function wioPopoutMenu(element: string, popoutElement: string): void {
    const container: HTMLDivElement | null = document.querySelector(element);
    const subnav: HTMLDivElement | null = document.querySelector(popoutElement);

    if (container && subnav) {
        popoutMenu(container, subnav);
        scrollToActiveCategory(subnav);
    }
}

const scrollToActiveCategory = (subnav: HTMLDivElement) => {
    let firstClick = true;

    subnav.addEventListener(EVENT.CATEGORY_MENU_VISIBILITY_CHANGE, () => {
        if (subnav.classList.contains(IS_VISIBLE) && firstClick) {
            const activeElement: HTMLAnchorElement | null = subnav.querySelector('.selected');
            const subnavContainer: HTMLDivElement | null = subnav.querySelector('.subnav');

            if (activeElement && subnavContainer) {
                const offset: number = activeElement.offsetTop;

                subnavContainer.scrollTop = offset - 10;

                firstClick = false;
            }
        }
    });
};

wioPopoutMenu('.js-popout-menu-categories', '.js-wio__categories');
wioPopoutMenu('.js-popout-menu-views', '.js-wio__views');
